import { useTranslation } from "@redotech/redo-i18n";
import type { CustomerEmailState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { memo, useMemo, useState } from "react";

export const CustomerEmailDetails = memo(function CustomerEmailDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<CustomerEmailState>) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  const tags = useMemo(
    () => state.map((email) => ({ text: email, color: "gray" as const })),
    [state],
  );

  return (
    <RedoTagInputField
      delimiters={["newline"]}
      inputValue={inputValue}
      label={t("Customer emails")}
      placeholder={t("Type and press Enter to add emails")}
      setInputValue={setInputValue}
      setTags={setState}
      size="sm"
      state={disabled ? "disabled" : "default"}
      tags={tags}
    />
  );
});
